"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bosEmployeeQuery = void 0;
const types_1 = require("../../types");
exports.bosEmployeeQuery = `
  query employee( $email: String ) {
    employee( email: $email ) {
      ...bosEmployee
    }
  }
  ${types_1.employeeFragment}
  ${types_1.employeeRoleFragment}
`;
//# sourceMappingURL=employeeQuery.js.map